import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { KeysEnum, KeysOfType } from 'src/app/helpers/utility-functions';
import { IPBoardConfigurationInfo } from 'src/app/model/product/ip-board/ip-board-configuration-info';
import { REGISTERED_ACTION_TYPES } from 'src/app/model/registered-action-type';
import { AtelierDetailIPBoardRegisteredAction } from '../../model/atelier-detail-ip-board-registered-action';
import { AtelierDetailProduct } from '../../model/atelier-detail-product';

export class AtelierItemDetailHelper {
  private constructor() {}

  static processConfigurationInfo(
    product: AtelierDetailProduct
  ): AtelierConfigurationInfo {
    const hasRegisteredActions = CollectionHelper.isPopulated(
      product.registeredActions
    );
    const printRegisteredAction: AtelierDetailIPBoardRegisteredAction =
      hasRegisteredActions
        ? product.registeredActions.find(
            (r) =>
              r.type != null &&
              r.type.ordinal ===
                REGISTERED_ACTION_TYPES.REGISTER_IMMO_PRINT.ordinal
          )
        : null;
    const textRegisteredAction: AtelierDetailIPBoardRegisteredAction =
      hasRegisteredActions
        ? product.registeredActions.find(
            (r) =>
              r.type != null &&
              r.type.ordinal ===
                REGISTERED_ACTION_TYPES.REGISTER_IMMO_TEXT.ordinal
          )
        : null;
    const extraBoardTextRegisteredAction: AtelierDetailIPBoardRegisteredAction =
      hasRegisteredActions
        ? product.registeredActions.find(
            (r) =>
              r.type != null &&
              r.type.ordinal ===
                REGISTERED_ACTION_TYPES.REGISTER_IMMO_EXTRA_BOARD_TEXT.ordinal
          )
        : null;

    return {
      leftDefaultTitle: this.evaluateConfigurationInfo(
        product,
        'titleConfigurationInfo',
        'leftIsDefault',
        true
      ),
      leftTitleFromStock: this.evaluateConfigurationInfo(
        product,
        'titleConfigurationInfo',
        'leftAdjustmentFromStock',
        false
      ),
      leftTitleFromPrintwork: this.evaluateConfigurationInfo(
        product,
        'titleConfigurationInfo',
        'leftFromPrintwork',
        false
      ),
      leftDefaultPhoneNumber: this.evaluateConfigurationInfo(
        product,
        'phoneNumberConfigurationInfo',
        'leftIsDefault',
        true
      ),
      leftPhoneNumberFromStock: this.evaluateConfigurationInfo(
        product,
        'phoneNumberConfigurationInfo',
        'leftAdjustmentFromStock',
        false
      ),
      leftPhoneNumberFromPrintwork: this.evaluateConfigurationInfo(
        product,
        'phoneNumberConfigurationInfo',
        'leftFromPrintwork',
        false
      ),
      rightDefaultTitle: this.evaluateConfigurationInfo(
        product,
        'titleConfigurationInfo',
        'rightIsDefault',
        true
      ),
      rightTitleFromStock: this.evaluateConfigurationInfo(
        product,
        'titleConfigurationInfo',
        'rightAdjustmentFromStock',
        false
      ),
      rightTitleFromPrintwork: this.evaluateConfigurationInfo(
        product,
        'titleConfigurationInfo',
        'rightFromPrintwork',
        false
      ),
      rightDefaultPhoneNumber: this.evaluateConfigurationInfo(
        product,
        'phoneNumberConfigurationInfo',
        'rightIsDefault',
        true
      ),
      rightPhoneNumberFromStock: this.evaluateConfigurationInfo(
        product,
        'phoneNumberConfigurationInfo',
        'rightAdjustmentFromStock',
        false
      ),
      rightPhoneNumberFromPrintwork: this.evaluateConfigurationInfo(
        product,
        'phoneNumberConfigurationInfo',
        'rightFromPrintwork',
        false
      ),
      printRegisteredDate:
        printRegisteredAction == null ? null : printRegisteredAction.date,
      printRegisteredUser:
        printRegisteredAction == null ? null : printRegisteredAction.initials,
      textRegisteredDate:
        textRegisteredAction == null ? null : textRegisteredAction.date,
      textRegisteredUser:
        textRegisteredAction == null ? null : textRegisteredAction.initials,
      extraBoardTextRegisteredDate:
        extraBoardTextRegisteredAction == null
          ? null
          : extraBoardTextRegisteredAction.date,
      extraBoardTextRegisteredUser:
        extraBoardTextRegisteredAction == null
          ? null
          : extraBoardTextRegisteredAction.initials,
    };
  }

  private static evaluateConfigurationInfo(
    product: AtelierDetailProduct,
    infoKey: KeysOfType<AtelierDetailProduct, IPBoardConfigurationInfo>,
    configKey: KeysOfType<IPBoardConfigurationInfo, boolean>,
    fallbackIfNull: boolean
  ): boolean {
    return product[infoKey] == null
      ? fallbackIfNull
      : product[infoKey][configKey];
  }
}

export interface AtelierConfigurationInfo {
  leftDefaultTitle: boolean;
  leftTitleFromStock: boolean;
  leftTitleFromPrintwork: boolean;
  leftDefaultPhoneNumber: boolean;
  leftPhoneNumberFromStock: boolean;
  leftPhoneNumberFromPrintwork: boolean;
  rightDefaultTitle: boolean;
  rightTitleFromStock: boolean;
  rightTitleFromPrintwork: boolean;
  rightDefaultPhoneNumber: boolean;
  rightPhoneNumberFromStock: boolean;
  rightPhoneNumberFromPrintwork: boolean;
  printRegisteredDate: Date;
  printRegisteredUser: string;
  textRegisteredDate: Date;
  textRegisteredUser: string;
  extraBoardTextRegisteredDate: Date;
  extraBoardTextRegisteredUser: string;
}

export const AtelierConfigurationInfoKeys: KeysEnum<AtelierConfigurationInfo> =
  {
    leftDefaultTitle: true,
    leftTitleFromStock: true,
    leftTitleFromPrintwork: true,
    leftDefaultPhoneNumber: true,
    leftPhoneNumberFromStock: true,
    leftPhoneNumberFromPrintwork: true,
    rightDefaultTitle: true,
    rightTitleFromStock: true,
    rightTitleFromPrintwork: true,
    rightDefaultPhoneNumber: true,
    rightPhoneNumberFromStock: true,
    rightPhoneNumberFromPrintwork: true,
    printRegisteredDate: true,
    printRegisteredUser: true,
    textRegisteredDate: true,
    textRegisteredUser: true,
    extraBoardTextRegisteredDate: true,
    extraBoardTextRegisteredUser: true,
  };
